import { portalBase2v, publicBase2v } from '@App/dicts/pathes'

export class Auth {
    signIn = publicBase2v('user/login')
    mfaSubmit = publicBase2v('user/mfa-confirm')
    logOut = portalBase2v('logout')
    forgotPassword = publicBase2v('user/forgot-password')
    confirmForgotPassword = publicBase2v('user/confirm-forgot-password')
}
